"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _request = _interopRequireDefault(require("@/utils/request"));
var _formatMixin = require("@/utils/formatMixin");
var _funnelChart = _interopRequireDefault(require("@/components/chart/funnelChart.vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  name: 'Dashboard',
  components: {
    funnelChart: _funnelChart.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      data: null,
      money_hkhk_tj: 0,
      money_htshc_tj: 0,
      money_yetx_tj: 0,
      money_yczf_tj: 0,
      money_qita_tj: 0,
      money_fan_tj: 0,
      vy_num: 0,
      vy_sum_money: 0,
      vy_dh_money: 0,
      yq_num: 0,
      us_num: 0,
      dq_num: 0,
      wc_num: 0,
      wc_lv: 100,
      yq_lv: 0,
      value1: '',
      listLoading: false,
      salesData: [
        // { name: '原味麦利奥 500g', value: 80, status: 'info' },
        // { name: '乡巴佬鸡爪 250g', value: 60, status: 'info' },
        // { name: '可口可乐 500ml', value: 40, status: 'info' },
        // { name: '无骨凤爪 200g', value: 30, status: 'info' },
        // { name: '火炕生料 500g', value: 50, status: 'info' },
        // { name: '康师傅麻辣牛肉面 150g', value: 70, status: 'info' }
      ],
      maxValue: 0,
      info_result: null
    };
  },
  created: function created() {
    // 请求index数据
    this.getIndexData();
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    // 订单漏斗转化图数据
    funnelOptions: function funnelOptions() {
      return {
        // title: {
        //   text: '订单状态转化漏斗',
        //   // left: 'center'
        // },
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          data: ['正常订单', '待归还', '已支付新订单']
        },
        series: [{
          name: '订单转化',
          type: 'funnel',
          left: '10%',
          top: 60,
          bottom: 60,
          width: '80%',
          min: 0,
          minSize: '0%',
          maxSize: '100%',
          sort: 'descending',
          gap: 2,
          label: {
            show: true,
            position: 'inside'
          },
          labelLine: {
            length: 0
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          emphasis: {
            label: {
              fontSize: 20
            }
          },
          data: [{
            value: 0,
            name: '正常订单'
          }, {
            value: 0,
            name: '待归还'
          }, {
            value: 0,
            name: '已支付新订单'
          }
          //   { value: 0, name: '待支付新订单' },
          //   { value: 0, name: '待签约新订单' },
          //   { value: 0, name: '完成扣款订单' },
          //   { value: 0, name: '已完成订单' },
          //   { value: 0, name: '已完成' },
          //   { value: 0, name: '已支付续费订单' },
          //   { value: 0, name: '代扣续费订单' },
          //   { value: 0, name: '逾期订单' },
          //   { value: 0, name: '违约订单' },
          //   { value: 0, name: '续费订单' }
          ]
        }]
      };
    },
    // isAdmin
    // 如果perms包含 admin 字段 即为管理员，则返回true  否则为false
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    },
    start_time: function start_time() {
      return this.value1[0] ? this.formatDate(this.value1[0]) : this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    },
    end_time: function end_time() {
      return this.value1[1] ? this.formatDate(this.value1[1]) : this.formatDate(new Date());
    }
  }),
  methods: {
    SwitchPlatform: function SwitchPlatform() {
      console.log('切换平台');
      window.location.href = 'https://httwo.99zuji.com/';
    },
    // 格式化日期
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    getMoneyReal2: function getMoneyReal2() {
      var _this = this;
      (0, _request.default)({
        url: "/system/order/get_statics_ab/",
        method: 'put',
        data: {
          type: 1,
          shop_id: this.$user.data.shop,
          end_time: this.end_time,
          start_time: this.start_time
        }
      }).then(function (response) {
        // console.log(response)
        if (response.data) {
          _this.vy_num = response.data.vy_num;
          _this.vy_sum_money = response.data.vy_sum_money;
          _this.vy_dh_money = response.data.vy_dh_money;
          _this.yq_num = response.data.yq_num;
          _this.us_num = response.data.us_num;
          _this.dq_num = response.data.dq_num;
          _this.wc_num = response.data.wc_num;
          _this.wc_lv = response.data.wc_lv;
          _this.yq_lv = response.data.yq_lv;
        }
        _this.getMoneyReal3();
        _this.listLoading = false;
      });
    },
    getMoneyReal3: function getMoneyReal3() {
      var _this2 = this;
      (0, _request.default)({
        url: "/system/order/get_statics_cd/",
        method: 'put',
        data: {
          type: 1,
          shop_id: this.$user.data.shop
          //   end_time: this.end_time,
          //   start_time: this.start_time
        }
      }).then(function (response) {
        if (response.data) {
          var info_result = response.data;
          console.log(info_result);
          _this2.info_result = response.data;
          // 给漏斗图赋值
          _this2.funnelOptions.series[0].data = [{
            value: _this2.info_result.zc_num,
            name: '正常订单'
          }, {
            value: _this2.info_result.dgh_num,
            name: '待归还'
          }, {
            value: _this2.info_result.pay_num,
            name: '已支付新订单'
          }];

          // 给进度条赋值
          _this2.salesData = [{
            name: '待支付新订单',
            value: info_result.to_pay_num,
            status: 'info'
          }, {
            name: '待签约新订单',
            value: info_result.to_deduct_num,
            status: 'info'
          }, {
            name: '完成扣款订单',
            value: info_result.dk_num,
            status: 'info'
          },
          // { name: '已完成订单', value: info_result.h_num, status: 'info' },
          // { name: '已完成', value: info_result.ywc_num, status: 'info' },
          {
            name: '已支付续费订单',
            value: 0,
            status: 'info'
          }, {
            name: '代扣续费订单',
            value: 0,
            status: 'info'
          }, {
            name: '逾期订单',
            value: info_result.yq_num,
            status: 'info'
          }, {
            name: '违约订单',
            value: info_result.vy_num,
            status: 'info'
          }, {
            name: '续费订单',
            value: 0,
            status: 'info'
          }];
          _this2.maxValue = info_result.to_pay_num + 500;
          _this2.$nextTick(function () {
            _this2.init = true;
          });
          // this.vy_num= response.data.vy_num
          // this.vy_sum_money= response.data.vy_sum_money
          // this.vy_dh_money= response.data.vy_dh_money
          // this.yq_num= response.data.yq_num
          // this.dq_num= response.data.dq_num
          // this.wc_num= response.data.wc_num
          // this.wc_lv= response.data.wc_lv
          // this.yq_lv= response.data.yq_lv
        }
        _this2.listLoading = false;
      });
    },
    getMoneyReal: function getMoneyReal(type) {
      var _this3 = this;
      (0, _request.default)({
        url: "/system/order/get_statics_bc/",
        method: 'put',
        data: {
          type: type,
          shop_id: this.$user.data.shop
        }
      }).then(function (response) {
        if (response.data) {
          if (type == 1) {
            _this3.money_hkhk_tj = response.data.money;
          }
          if (type == 2) {
            _this3.money_htshc_tj = response.data.money;
          }
          if (type == 3) {
            _this3.money_yczf_tj = response.data.money;
          }
          if (type == 4) {
            _this3.money_yetx_tj = response.data.money;
          }
          if (type == 5) {
            _this3.money_qita_tj = response.data.money;
          }
          if (type == 6) {
            _this3.money_fan_tj = response.data.money;
          }
          // this.orderList = response.data
          // this.orderList = this.orderList.reverse()
        }
        _this3.listLoading = false;
      });
    },
    // 获取数据
    getIndexData: function getIndexData() {
      var _this4 = this;
      var complain_count = this.$store.state.user.complain_count;
      if (complain_count > 0) {
        this.$confirm('提示存在未处理的订单投诉信息，请前往处理', '提示', {
          type: 'success',
          confirmButtonText: '好的',
          showCancelButton: false
        }).then(function () {
          console.log('操作成功');
        });
      }
      this.listLoading = true;
      (0, _request.default)({
        url: "/dashboard/stat2",
        method: 'post',
        data: {
          end_time: this.end_time,
          start_time: this.start_time
        }
      }).then(function (response) {
        if (response.data) {
          _this4.data = response.data;

          //   // 给漏斗图赋值
          //   this.funnelOptions.series[0].data = [
          //     { value: this.data.zc_num, name: '正常订单' },
          //     { value: this.data.dgh_num, name: '待归还' },
          //     { value: this.data.pay_num, name: '已支付新订单' }
          //   ]

          //   // 给进度条赋值
          //   this.salesData = [
          //     { name: '待支付新订单', value: this.data.to_pay_num, status: 'info' },
          //     { name: '待签约新订单', value: this.data.to_deduct_num, status: 'info' },
          //     { name: '完成扣款订单', value: this.data.dk_num, status: 'info' },
          //     { name: '已完成订单', value: this.data.h_num, status: 'info' },
          //     { name: '已完成', value: this.data.ywc_num, status: 'info' },
          //     { name: '已支付续费订单', value: this.data.xf_pay_num, status: 'info' },
          //     { name: '代扣续费订单', value: this.data.xf_dk_num, status: 'info' },
          //     { name: '逾期订单', value: this.data.yq_num, status: 'info' },
          //     { name: '违约订单', value: this.data.vy_num, status: 'info' },
          //     { name: '续费订单', value: this.data.xf_num, status: 'info' },

          //   ]

          //   this.maxValue = this.data.to_pay_num + 500

          //   this.$nextTick(() => {
          //     this.init = true
          //   })
        }
        _this4.listLoading = false;
        _this4.getMoneyReal2();
      });
    },
    // 重置数据
    resetData: function resetData() {
      this.value1 = '';
      this.getIndexData();
    }
  }
};